import { ANALYSIS_PROFILES } from './analyses/analysis-profile';
import { Analysis, Granularity, Metric } from './dashboard-config.model';
import { GRANULARITY_PROFILES } from './granularities/granularity-profile';
import { METRIC_PROFILES } from './metrics/metric-profile-implementations';
import { DATASET_TOKEN_OVERRIDES } from './product-rules';

/** Metric segments of ids with no metric profile. */
const LEGACY_METRIC_DATASET_TOKENS: Readonly<Record<number, string>> = {
  // Gender distribution; its dashboards (6x5x*) name their dataset themselves.
  6: 'emd__gd',
};

function metricToken(metricId?: number): string {
  if (metricId === undefined) return '';
  return METRIC_PROFILES[metricId as Metric]?.datasetToken ?? LEGACY_METRIC_DATASET_TOKENS[metricId] ?? '';
}

function analysisToken(analysisId?: number): string {
  return analysisId === undefined ? '' : ANALYSIS_PROFILES[analysisId as Analysis]?.datasetToken ?? '';
}

function granularityToken(granularityId?: number, analysisId?: number): string {
  if (granularityId === undefined) return '';
  const override = DATASET_TOKEN_OVERRIDES.find(
    (rule) => rule.granularity === granularityId && rule.analysis === analysisId,
  );
  return override?.token ?? GRANULARITY_PROFILES[granularityId as Granularity]?.datasetToken ?? '';
}

/** `ds__{metric}__{analysis}__{granularity}__vm` (empty segments omitted). */
export function composeDatasetName(options: {
  metricId?: number;
  analysisId?: number;
  granularityId?: number;
  /** When set, replaces the analysis segment derived from analysisId. */
  analysisToken?: string;
}): string {
  return [
    'ds',
    metricToken(options.metricId),
    options.analysisToken ?? analysisToken(options.analysisId),
    granularityToken(options.granularityId, options.analysisId),
    'vm',
  ]
    .filter((part) => part !== '')
    .join('__');
}
